/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Branding_AvatarInputs */

const cs_templates_branding_avatar = /** @type {(inputs: Templates_Branding_AvatarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto makléře (avatar)`)
};

const en_templates_branding_avatar = /** @type {(inputs: Templates_Branding_AvatarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broker photo (avatar)`)
};

/**
* | output |
* | --- |
* | "Broker photo (avatar)" |
*
* @param {Templates_Branding_AvatarInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_branding_avatar = /** @type {((inputs?: Templates_Branding_AvatarInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Branding_AvatarInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_branding_avatar(inputs)
	return cs_templates_branding_avatar(inputs)
});